export default "__VITE_ASSET__5V766yka__"